// extracted by mini-css-extract-plugin
export default {"button":"BurgerButton_button__WQ5XD","open":"BurgerButton_open__OtPgX"};